import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import HeaderSection from '@/pages/public/home/sections/header.section.view';
import FooterSection from '@/pages/public/home/sections/footer.section.view';
import '../../styles/home.desktop.scss';
import '../../styles/home.mobile.scss';

export type Lang = 'en' | 'mk' | 'al';

interface PageTemplateProps {
  lang: Lang;
  setLang: React.Dispatch<React.SetStateAction<Lang>>;
  t: any;
  children: React.ReactNode;
  forceScrolled?: boolean;
}

const PageTemplate: React.FC<PageTemplateProps> = ({ lang, setLang, t, children, forceScrolled = false }) => {
  // Navigation handler for scrolling to sections
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    if (sectionId === 'race-info') {
      // Let Link handle navigation in HeaderSection
      return;
    }
    e.preventDefault();
    setTimeout(() => {
      const section = document.getElementById(sectionId);
      if (section) {
        const yOffset = -80;
        const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div className="home-container">
      <HeaderSection t={t} setLang={setLang} handleNavClick={handleNavClick} forceScrolled={forceScrolled} />
      <div className="main-content">
        {children}
        <FooterSection t={t} setLang={setLang} />
      </div>
    </div>
  );
};

export default PageTemplate;
